import { render, staticRenderFns } from "./AliVideo.vue?vue&type=template&id=a8fcee1c&scoped=true"
import script from "./AliVideo.vue?vue&type=script&lang=js"
export * from "./AliVideo.vue?vue&type=script&lang=js"
import style0 from "./AliVideo.vue?vue&type=style&index=0&id=a8fcee1c&prod&scoped=true&lang=css"
import style1 from "./AliVideo.vue?vue&type=style&index=1&id=a8fcee1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fcee1c",
  null
  
)

export default component.exports